import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import Footer from '../common/Footer';
import RequestCard from './RequestCard';
import MobileNotification from '../common/MobileNotification';
import MobileMessage from '../common/MobileMessage';
import PageLoader from '../common/PageLoader';
import SearchEmptyState from '../EmptyState/SearchEmptyState';
import { queryStringtoArray, removeParameterFromUrl } from '../../helpers/index';
import { findIndex, filter, take, map } from 'lodash';
import { Link } from 'react-scroll';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import ReactRotatingText from 'react-rotating-text';
import Button from '../common/Button';
import MobileHeaderSearch from '../common/MobileHeaderSearch';
import { imageBasePath, appBasePath } from '../../constants/staticData';

export default class SearchResult extends Component {
  constructor(props, context) {
    super(props, context);
    this.searchVendors = this.searchVendors.bind(this);
    this.toggleNotification = this.toggleNotification.bind(this);
    const userSelectedLocation = localStorage.getItem('userSelectedLocation') ? JSON.parse(localStorage.getItem('userSelectedLocation')) : {};
    this.state = {
      searchMobile: false,
      locationSearchTerm: userSelectedLocation && userSelectedLocation.label ? userSelectedLocation.label : "",
      searchText: "",
      autoCompleteData: [],
      autoSuggestedList: props.commonReducer && props.commonReducer.autoSuggestedList ? props.commonReducer.autoSuggestedList : [],
      alreadySearched: false,
      isLoading: true,
      notificationVisible: false,
      messageVisible: false,
      filterActivated: false,
      sidebarProfileDropdown: false,
    };
  }

  toggleNotification(isVisible) {
    this.setState({ 'notificationVisible': isVisible });
  }

  componentDidMount() {
    // this.setState({ isLoading: true });
    this.props.actions.clearCommonReducerComponentKey();

    if (!(this.props.commonReducer.autoSuggestedList && this.props.commonReducer.autoSuggestedList.length)) {
      this.props.actions.getAutosuggestedList();
    }
    if (!localStorage.getItem('authData') && !this.state.alreadySearched) {
      if (queryStringtoArray('q')) {
        this.searchVendors(queryStringtoArray('q'), 'keyword');
        this.setState({ searchMobile: false, alreadySearched: true, serviceSearchTerm: decodeURI(queryStringtoArray('q')), searchText: decodeURI(queryStringtoArray('q')) });
      } else {
        // this.searchVendors('', 'keyword');
        const userSelectedLocation = localStorage.getItem('userSelectedLocation') ? JSON.parse(localStorage.getItem('userSelectedLocation')) : undefined;
        let searchLocation = userSelectedLocation;
        if (searchLocation == undefined) {
          searchLocation = this.props.commonReducer.userLocation;
        } else {
          searchLocation = { latitude: userSelectedLocation.lat, longitude: userSelectedLocation.lng }
        }
        if (searchLocation && searchLocation.latitude && searchLocation.longitude && (queryStringtoArray('lat'))) {
          this.props.actions.searchVendors(false, false, searchLocation, 'distance');
        }else{
          this.setState({ isLoading: false});
        }
        this.setState({ searchMobile: false, alreadySearched: true });
      }
    } else {
      this.setState({ searchMobile: false });
    }
  }

  toggleMessage(isVisible) {
    this.setState({ 'messageVisible': isVisible });
  }

  autocompleteLocation(e) {
    let that = this;
    const searchTerm = e.target.value;
    if (searchTerm) {
      that.setState({
        'locationSearchTerm': searchTerm
      });
      let places = new google.maps.places.AutocompleteService();
      places.getPlacePredictions({ 'input': searchTerm }, function (res) {
        that.setState({
          'autoCompleteData': res
        });
      });
    } else {
      localStorage.removeItem('userSelectedLocation');
      this.props.actions.setCurrentLocation({});
      that.setState({
        'locationSearchTerm': searchTerm,
        'autoCompleteData': []
      });
    }
  }

  setUserLocation(location, searchTerm) {
    const that = this;
    let geoCodeParams = {};
    if (location && ((location.lat && location.lng) || location.place_id)) {
      if (location && location.lat && location.lng) {
        geoCodeParams['location'] = { 'lat': Number(location.lat), 'lng': Number(location.lng) };
      } else if (location.place_id) {
        geoCodeParams['placeId'] = location.place_id;
      }
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode(geoCodeParams, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK && results && results.length) {
          this.setState({ 'userLocation': results[0], 'locationSearchTerm': searchTerm || location.description || results[0].formatted_address, 'showLocationDropdown': false });
          that.props.actions.setCurrentLocation({
            'lat': results[0].geometry.location.lat(),
            'lng': results[0].geometry.location.lng(),
            'formatted_address': results[0].formatted_address,
            'label': searchTerm || location.description || results[0].formatted_address
          })
        } else {
          this.setState({ 'showLocationDropdown': false });
        }
      });
    }
  }

  searchVendors(data, type) {
    const userSelectedLocation = localStorage.getItem('userSelectedLocation') ? JSON.parse(localStorage.getItem('userSelectedLocation')) : undefined;
    let searchLocation = userSelectedLocation;
    if (searchLocation == undefined) {
      searchLocation = this.props.commonReducer.userLocation;
    } else {
      searchLocation = { latitude: userSelectedLocation.lat, longitude: userSelectedLocation.lng }
    }
    searchLocation = searchLocation && searchLocation.latitude && searchLocation.longitude ? searchLocation : undefined;
    if (type == "keyword") {
      if (data) {
        let index = findIndex(this.state.autoSuggestedList, { name: data });
        if (index != -1) {
          this.searchVendors(this.state.autoSuggestedList[index], 'autosuggest');
        } else {
          this.props.actions.searchVendors(type, data, searchLocation, "distance");
        }
      } else if (searchLocation && searchLocation.latitude && searchLocation.longitude) {
        this.props.actions.searchVendors(false, false, searchLocation, "distance");
      } else {
        let href = window.location.href;
        let updatedUrl = removeParameterFromUrl(href, 'q');
        // window.location.href = updatedUrl;
        window.history.replaceState(null, null, updatedUrl);
      }
    } else if (type == "autosuggest") {
      if (data) {
        this.props.actions.searchVendors(type, data, searchLocation, "distance");
      } else if (searchLocation && searchLocation.latitude && searchLocation.longitude) {
        this.props.actions.searchVendors(false, false, searchLocation, "distance");
      } else {
        let href = window.location.href;
        let updatedUrl = removeParameterFromUrl(href, 'q');
        // window.location.href = updatedUrl;
        window.history.replaceState(null, null, updatedUrl);
      }
    }
  }

  componentWillReceiveProps(nextProps) {




    if (nextProps.commonReducer.isLoaded) {
      this.setState({ isLoading: false });
      this.props.actions.clearCommonReducerComponentKey();
    }
    if (nextProps.commonReducer && nextProps.commonReducer.autoSuggestedList && !this.state.autoSuggestedList.length) {
      this.setState({ autoSuggestedList: nextProps.commonReducer.autoSuggestedList });
    }

    if(!window.location.href.includes('top-car')){
      if (!localStorage.getItem('authData') && !this.state.alreadySearched) {
        if (queryStringtoArray('q')) {
          this.searchVendors(queryStringtoArray('q'), 'keyword');
          this.setState({ searchMobile: false, alreadySearched: true, serviceSearchTerm: decodeURI(queryStringtoArray('q')), searchText: decodeURI(queryStringtoArray('q')) });
        } else {
          // this.searchVendors('', 'keyword');
          const userSelectedLocation = localStorage.getItem('userSelectedLocation') ? JSON.parse(localStorage.getItem('userSelectedLocation')) : undefined;
          let searchLocation = userSelectedLocation;
          if (searchLocation == undefined) {
            searchLocation = this.props.commonReducer.userLocation;
          } else {
            searchLocation = { latitude: userSelectedLocation.lat, longitude: userSelectedLocation.lng }
          }
          if (searchLocation && searchLocation.latitude && searchLocation.longitude && (queryStringtoArray('lat'))) {
            this.props.actions.searchVendors(false, false, searchLocation, 'distance');
          }
          this.setState({ searchMobile: false, alreadySearched: true });
        }
      } else {
        this.setState({ searchMobile: false });
      }
    } else {
      if(!this.state.alreadySearched){
        this.setState({  alreadySearched: true});
        this.searchVendors('all', 'keyword');
      }
    }

  }
  filterActivated(filterActivated) {
    this.setState({
      filterActivated: filterActivated
    });
  }
  render() {
    const { commonReducer, actions, router,bookingRequestReducer } = this.props;
    let searchView = filter(this.state.autoSuggestedList, (val) => {
      if (this.state.searchText != "" && val.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) != -1) {
        return val;
      }
    });
    searchView = take(searchView, 5);
    const searchAutoSuggestedList = map(searchView, (val, key) => {
      return (
        <MenuItem onClick={() => {
          this.setState({ 'searchText': val.name });
          // this.searchVendors(val, 'autosuggest');
        }} eventKey={key} key={key}>{val.name}</MenuItem>
      );
    });

    let locationData = [{ "textPlaceholder": "Current Location" }]
    map(this.state.autoCompleteData, (location, key) => {
      return (
        locationData.push({ "key": key, "description": location.description, 'place_id': location.place_id })
      );
    });
    map(this.props.commonReducer && this.props.commonReducer.userLocations, (location, key) => {
      return (
        locationData.push({ "key": key, 'lat': location.lat, 'lng': location.lng, 'label': location.label, 'id': location.id, 'formatted_address': location.location })
      );
    });
    const locationAutosuggestedList = map(locationData, (val, key) => {
      return (
        <MenuItem onClick={(item, ) => {
          if (item.target.text != "Current Location") { this.setUserLocation(val, item.target.text); } else {
            if (navigator.geolocation) {
              const that = this;
              navigator.geolocation.getCurrentPosition(function (position) {
                that.setUserLocation({ 'lat': position.coords.latitude, 'lng': position.coords.longitude });
              }, function (error) {
                switch (error.code) {
                  case error.PERMISSION_DENIED:
                    that.props.actions.showToastMessage('Please grant permission to use location service', 'error');
                    break;
                  case error.POSITION_UNAVAILABLE:
                    that.props.actions.showToastMessage('Location information is unavailable.', 'error');
                    break;
                  case error.TIMEOUT:
                    that.props.actions.showToastMessage('The request to get user location timed out.', 'error');
                    break;
                  case error.UNKNOWN_ERROR:
                    that.props.actions.showToastMessage('An unknown error occurred.', 'error');
                    break;
                }
              }, {maximumAge:Infinity, timeout:3000});
            } else {
              this.props.actions.showToastMessage('Geo location feature is not available in your browser', 'error');
            }
          }
        }} eventKey={key} key={key}>{val.description ? val.description : val.label ? val.label : val.textPlaceholder}</MenuItem>
      );
    });

    console.log("this.state.isLoading",this.state.isLoading)

    return (
      <div>
        {!localStorage.getItem('authData') ? <div id="landing" ref="landing">
          <nav className="navbar navbar-default default-header search-result-header" id="header-section1">
            <div className="container-fluid">
              <div className="navbar-header">
                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" onClick={() => { this.setState({ 'navbarVisible': !this.state.navbarVisible }) }}>
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
                <a className="navbar-brand desk-logo" onClick={(e) => { e.preventDefault(); this.props.router.push(appBasePath + '/'); }}>
                  <img src={imageBasePath + "/images/landing/car-service-in-dubai-carcility-logo.svg"}  alt="Car service in Dubai,car repair , car maintenance ,carcility-logo" />
                </a>
                {/*<a className="navbar-brand mobile-logo" href="https://www.carcility.com" onClick={(e) => { e.preventDefault(); this.props.router.push('/'); }}>
                  <img src="/images/logo.svg" />
                </a>*/}
              </div>
              {/*Search mobile for mobile */}
              <span className="search-mobile sm-mob" onClick={() => this.setState({ searchMobile: true })}>
                <i className="mdi mdi-magnify" aria-hidden="true" />
              </span>
              <div id="navbar" className={this.state.navbarVisible ? "navbar-collapse" : "navbar-collapse collapse"}>
                <ul className="nav navbar-nav navbar-right">
                  <li className="search-mobile md-mob" onClick={() => this.setState({ searchMobile: true })}>
                    <i className="mdi mdi-magnify" aria-hidden="true" />
                  </li>
                  <li className="work-active">
                    <Link to="how-works" smooth={true} offset={-100} duration={600}>
                      how it works
                  </Link>
                    <label></label>
                  </li>
                  <li>
                    <a href="/business">
                      For Business
                  </a>
                    <label></label>
                  </li>
                  <li>
                    <a onClick={(e) => { e.preventDefault(); this.props.router.push(appBasePath + '/sign-in'); }}>Log In </a>
                    <label></label>
                  </li>
                  <li>
                    <a onClick={(e) => { e.preventDefault(); this.props.router.push(appBasePath + '/register'); }}> Sign Up</a>
                    <label></label>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <nav className="navbar navbar-default scroll-header search-result-header" id="header-section2">
            <div className="container-fluid">
              <div className="navbar-header">
                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" onClick={() => { this.setState({ 'navbarVisible': !this.state.navbarVisible }) }}>
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
                <a className="navbar-brand" onClick={(e) => { e.preventDefault(); this.props.router.push(appBasePath + '/'); }}>
                  <img src={imageBasePath + "/images/landing/car-service-in-dubai-carcility-logo.svg"}  alt="Car service in Dubai,car repair , car maintenance ,carcility-logo" />
                </a>
              </div>
              <div id="navbar" className={this.state.navbarVisible ? "navbar-collapse" : "navbar-collapse collapse"}>
                <ul className="nav navbar-nav nav-left">
                  <li>
                    <div className="banner-search">
                      <div className="search-wrapper">
                        <form className="form-inline">
                          <DropdownButton bsSize="small" id="dropdown-size-small" noCaret onToggle={(e) => this.setState({ locateMeDD: e })}
                            onSelect={(id, e) => this.setState({ locationSearchTerm: e.target.innerText })}
                            className="location-search" title={
                              <span className="search-left">
                                <i className="mdi mdi-crosshairs-gps mdi-greenIcon-gps"></i>
                                <input type="text" className="form-control" placeholder="Locate Me" value={this.state.locationSearchTerm} onChange={(e) => { e.preventDefault(); this.autocompleteLocation(e); this.setState({ 'locationSearchTerm': e.target.value }) }} />
                                <i className={this.state.locateMeDD ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down"}></i>
                              </span>

                            }>
                            {locationAutosuggestedList}
                          </DropdownButton>
                          <DropdownButton bsSize="small" id="dropdown-size-small"
                            noCaret
                            onToggle={(e) => this.setState({ serviceDD: e })}
                            open={this.state.searchText == "" ? false : this.state.serviceDD}
                            onChange={(e) => { this.setState({ searchText: e.target.value }) }}
                            onSelect={(id, e) => {
                              this.setState({ serviceSearchTerm: e.target.innerText });
                            }}
                            className="location-search search-service-block" title={
                              <span className="search-right" onClick={() => this.setState({ blinkText: false })}>
                                <input type="text" ref={(focusFunction) => this.inputFocus = focusFunction} className="form-control" onChange={(e) => { e.preventDefault; const serviceSearchTerm = e.target.value; this.setState({ 'serviceSearchTerm': serviceSearchTerm }) }} value={this.state.serviceSearchTerm} />
                                <input className={'hide'} type="submit" onClick={(e) => { e.preventDefault(); this.searchVendors(this.state.searchText, 'keyword'); }} />
                                <span onClick={() => { this.inputFocus.focus() }} className={this.state.blinkText ? "blink-text" : "blink-text hide"}>
                                  <ReactRotatingText items={["What service do you need today?"]} />
                                </span>
                                <i className="mdi mdi-magnify" onClick={() => { this.searchVendors(this.state.searchText, 'keyword'); }} />
                              </span>

                            }>
                            {searchAutoSuggestedList}
                          </DropdownButton>
                        </form>
                      </div>
                    </div>
                  </li>
                </ul>
                <ul className="nav navbar-nav navbar-right">
                  <li>
                    <Button isSubmitBtn={true} btnCallBack={() => { this.props.router.push(appBasePath + '/guest-user'); }} btnType="red" btnSize="sm" fontSize={13} label="Get Started" />
                  </li>
                  <li className="menu-option" onClick={() => this.setState({ sidebarOpen: !this.state.sidebarOpen, sidebarProfileDropdown: false })}>
                    <i className="mdi mdi-menu mdi-scroll-menu"></i>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div> : ''}
        <div className="jobUpdate">
          {/*Header*/}
          {localStorage.getItem('authData') ? <Header hideOption={() => this.setState({ searchMobile: true })} bookingRequestReducer = {bookingRequestReducer} commonReducer={commonReducer} notificationCount={2} profileName="Derrick Frank" notificationCallBack={this.toggleNotification} messageCallBack={this.toggleMessage.bind(this)} router={router} actions={actions} authReducer={this.props.authReducer} /> : ''}
          {localStorage.getItem('authData') ? <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} /> : ''}
          {localStorage.getItem('authData') ? <MobileMessage isVisible={this.state.messageVisible} backBtnCallBack={this.toggleMessage.bind(this)} /> : ''}
          <div className={localStorage.getItem('authData') ? "main-wrapper" : "main-wrapper no-padding no-margin"}>
            {/*Sidebar*/}
            {localStorage.getItem('authData') ? <Sidebar router={this.props.router} /> : ''}
            {/*message*/}
            {/*<Extra message="Your email account has been verified. We are open for service!" />*/}
            <div className={localStorage.getItem('authData') ? "page-sec-header" : "page-sec-header search-auth-page-header"}>
              <div className={localStorage.getItem('authData') ? "padwrapper" : "padwrapper fluid-width"}>
                <h4>Search Results</h4>
              </div>
            </div>
            {!this.state.isLoading ? (commonReducer.vendorsListFromSearch.length) || this.state.filterActivated ? <div className={localStorage.getItem('authData') ? "inSection" : "inSection search-auth-inSection"}>
              <div className={localStorage.getItem('authData') ? "padwrapper" : "padwrapper fluid-width"}>
                <div className="myCar-list request-wrapper">
                  <div className="myCar-body row">
                    {/*Job Updates*/}
                    <RequestCard {...this.props} filterActivated={this.filterActivated.bind(this)} />
                  </div>
                </div>
              </div>
            </div> : <SearchEmptyState /> : <div className="search-page-load"> <PageLoader /></div>}
          </div>
          <div className={localStorage.getItem('authData') ? "footerSection" : "footerSection"}>
            <Footer {...this.props} />
          </div>
        </div>
        {/* sidebar menu */}
        <div className={this.state.sidebarOpen ? "menu-sidebar active" : "menu-sidebar inactive"}>
          {/* <Sidebar router={this.props.router} open={this.state.sidebarProfileDropdown} profileClick={()=>this.setState({sidebarProfileDropdown:!this.state.sidebarProfileDropdown})}/> */}
          <div className="nonSignup-list">
            <ul className="list-unstyled">
              <li onClick={(e) => { e.preventDefault(); this.props.router.push(appBasePath + '/sign-in'); }}>
                <span>
                  LOG IN
                    </span>
              </li>
              <li onClick={(e) => { e.preventDefault(); this.props.router.push(appBasePath + '/register'); }}>
                <span>
                  SIGN UP
                    </span>
              </li>
              <li>
                <Link to="how-works" smooth={true} offset={-100} duration={600}>
                  <span>
                    HOW IT WORKS
                      </span>
                </Link>
              </li>
              <li onClick={(e) => { e.preventDefault(); window.location.pathname = '/business'; }}>
                <span>
                  FOR BUSINESS
                    </span>
              </li>
            </ul>
          </div>
        </div>
        {this.state.searchMobile && <div >

          <MobileHeaderSearch mobile={true} actions={this.props.actions} commonReducer={this.props.commonReducer} mobSearchClick={() => this.setState({ searchMobile: false })} />
        </div>}
      </div>
    );
  }
}

